pez.module('pagination', function($, $el) {
    var $posts = $el.closest('.posts');
    var href = $el.data().ajax || $el.attr('href');

    function setState(state) {
        switch(state) {
            case 'loading' :
                $el.html('Load More&hellip;');
                break;
            case 'loaded' :
                $el.html('Load More');
                break;
            case 'nomore' :
                $el.closest('.pagination').hide();
                break;
        }
    }

    function next() {
        setState('loading');
        $.get(href, function(data) {
            setState('loaded');

            var $html = $($.trim(data));
            var $newPosts = $html.find('.post');
            var $newPagination = $html.find('[data-module="pagination"]');
            if($newPosts.length) {
                $posts.find('.excerpts').append($newPosts);
                if($newPagination.length) {
                    href = $newPagination.data().ajax || $newPagination.attr('href');
                } else {
                    setState('nomore');
                }
            }
        });
        return false;
    }

    $el.click(next);
});
